import { render, staticRenderFns } from "./CooperationSection.vue?vue&type=template&id=627602fa&scoped=true&"
import script from "./CooperationSection.vue?vue&type=script&lang=js&"
export * from "./CooperationSection.vue?vue&type=script&lang=js&"
import style0 from "./CooperationSection.vue?vue&type=style&index=0&id=627602fa&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "627602fa",
  null
  
)

export default component.exports